import { render, staticRenderFns } from "./ProviderSummary.vue?vue&type=template&id=61a2b26e&scoped=true"
import script from "./ProviderSummary.vue?vue&type=script&lang=js"
export * from "./ProviderSummary.vue?vue&type=script&lang=js"
import style0 from "./ProviderSummary.vue?vue&type=style&index=0&id=61a2b26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2b26e",
  null
  
)

export default component.exports